<!-- Impersonation Banner - Fixed at top -->
<app-impersonation-banner></app-impersonation-banner>
<app-account-suspended-banner
  *ngIf="isLoggedIn && !isLoginRoute"
  [isDarkMode]="isDarkMode()">
</app-account-suspended-banner>
<app-version-update-banner
  *ngIf="isLoggedIn && !isLoginRoute && !isAdvancedEditorRoute"
  [isDarkMode]="isDarkMode()">
</app-version-update-banner>

<!-- AI evolution loop: aviso de version candidata esperando decision. -->
<app-evolution-proposal-modal
  *ngIf="isLoggedIn && !isLoginRoute"
  [isDarkMode]="isDarkMode()">
</app-evolution-proposal-modal>

<div class="min-h-full flex flex-col justify-start z-30" [ngClass]="{'dark bg-gray-900': isDarkMode(), 'bg-white': !isDarkMode()}">
  <nav id="mz-nav" data-track-zone="Navegación principal" class="shadow-lg relative z-[200]" [ngClass]="{'bg-white shadow-gray-200/50': !isDarkMode(), 'bg-gray-800 shadow-gray-800/50 border-b border-gray-700/60': isDarkMode()}" *ngIf="isLoggedIn && !isLoginRoute">
    <div class="mx-auto max-w-full">
      <div class="flex h-16 justify-between px-4 sm:px-6 md:px-8 lg:px-14">
        <div class="flex justify-between">

          <!-- LOGO -->
          <div class="flex flex-shrink-0 items-center">
            <!-- Partner logos have priority -->
            <img *ngIf="!this.loading && this.partner && this.partner.is === true && this.partner.id === 'meetzy-fkldasfhlajdhgshg'" src="{{this.partner.image}}" alt="logo" class="h-8 sm:h-10 w-auto">
            <img *ngIf="!this.loading && this.partner && this.partner.is === true && this.partner.id === 'iue92q38yr7etoversoft14fihlaiwuf08tf'" src="{{this.partner.image}}" alt="logo" class="h-6 sm:h-6 w-auto">
            <img *ngIf="!this.loading && this.partner && this.partner.is === true && this.partner.id === 'lkdjlfikjdhfap98eyemergiacc4fhiauhiqouh'" src="{{this.partner.image}}" alt="logo" class="h-8 sm:h-10 w-auto">
            <img *ngIf="!this.loading && this.partner && this.partner.is === true && this.partner.id === 'flark'" src="{{this.partner.image}}" alt="logo" class="h-8 sm:h-10 w-auto">
            <!-- Default meetzy logos when no partner -->
            <img *ngIf="!this.loading && (!this.partner || !this.partner.is) && !isDarkMode()" src="assets/images/meetzy_logo_transparent.png" alt="logo" class="h-8 sm:h-10 w-auto">
            <img *ngIf="!this.loading && (!this.partner || !this.partner.is) && isDarkMode()" src="assets/images/meetzy_white.png" alt="logo" class="h-8 sm:h-10 w-auto">
          </div>

          
        </div>

        <!-- Mobile menu button -->
        <div class="flex items-center sm:hidden">
          <button (click)="toggleMobileMenu()" type="button" class="inline-flex items-center justify-center rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-emerald-500" [ngClass]="{'text-gray-400 hover:bg-gray-100 hover:text-gray-500': !isDarkMode(), 'text-gray-300 hover:bg-gray-700 hover:text-gray-200': isDarkMode()}" aria-controls="mobile-menu" aria-expanded="false">
            <span class="sr-only">Open main menu</span>
            <!-- Icon when menu is closed -->
            <svg *ngIf="!mobileMenuOpen" class="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
            </svg>
            <!-- Icon when menu is open -->
            <svg *ngIf="mobileMenuOpen" class="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- NAVIGATION -->
        <div class="hidden sm:-my-px sm:flex sm:space-x-8">
          <!-- Current: "border-indigo-500 text-gray-900", Default: "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" -->
          
          <!-- AGENTS -->
          <div class="relative inline-block">
            <div class="cursor-pointer gap-2 h-full inline-flex cursor-pointer items-center border-b-2 px-1 pt-1 text-base font-medium agents-menu-trigger" 
                 [ngClass]="{'text-gray-900 hover:text-gray-700 border-slate-300 hover:border-emerald-300': !isDarkMode(), 'text-gray-100 hover:text-gray-300 border-gray-600 hover:border-emerald-400': isDarkMode()}"
                 [class.border-emerald-500]="router.url.includes('/playbooks') || router.url.includes('/agents')"
                 (click)="toggleAgentsMenu($event)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
              </svg>
              
              Agents
              <svg class="size-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            <div id="agents-menu" class="hidden absolute z-40 mt-2 w-72 rounded-md focus:outline-none" [ngClass]="{'bg-white shadow-lg ring-1 ring-black ring-opacity-5': !isDarkMode(), 'bg-gray-800 shadow-2xl shadow-black/50 ring-1 ring-gray-600 border border-gray-600': isDarkMode()}">
              <div class="p-4">
                <h3 class="text-base font-semibold" [ngClass]="{'text-gray-900': !isDarkMode(), 'text-gray-100': isDarkMode()}">Agent Management</h3>
                <p class="mt-1 text-sm" [ngClass]="{'text-gray-500': !isDarkMode(), 'text-gray-400': isDarkMode()}">Create and manage your AI agents</p>
              </div>
              <div class="border-t" [ngClass]="{'border-gray-100': !isDarkMode(), 'border-gray-700': isDarkMode()}">
                <div class="py-1">
                  <a routerLink="/agents" (click)="closeAllDesktopMenus()" class="cursor-pointer flex items-center px-4 py-3 text-sm" [ngClass]="{'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-300 hover:bg-gray-700': isDarkMode()}">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09Z" />
                    </svg>
                    All Agents
                  </a>
                  <a routerLink="/agents/voices" (click)="closeAllDesktopMenus()" class="cursor-pointer flex items-center px-4 py-3 text-sm" [ngClass]="{'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-300 hover:bg-gray-700': isDarkMode()}">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                    </svg>
                    Voice Library
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- CALLS -->
          <div class="relative inline-block">
            <div class="cursor-pointer gap-2 h-full inline-flex cursor-pointer items-center border-b-2 px-1 pt-1 text-base font-medium calls-menu-trigger" 
                 [ngClass]="{'text-gray-900 hover:text-gray-700 border-slate-300 hover:border-emerald-300': !isDarkMode(), 'text-gray-100 hover:text-gray-300 border-gray-600 hover:border-emerald-400': isDarkMode()}"
                 [class.border-emerald-500]="router.url.includes('/calls') || router.url.includes('/trends') || router.url.includes('/phones') || router.url.includes('/evaluation-trends')"
                 (click)="toggleCallsMenu($event)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
              </svg>
              Calls
              <svg class="size-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            <div id="calls-menu" class="hidden absolute z-40 mt-2 w-72 rounded-md focus:outline-none" [ngClass]="{'bg-white shadow-lg ring-1 ring-black ring-opacity-5': !isDarkMode(), 'bg-gray-800 shadow-2xl shadow-black/50 ring-1 ring-gray-600 border border-gray-600': isDarkMode()}">
              <div class="p-4">
                <h3 class="text-base font-semibold" [ngClass]="{'text-gray-900': !isDarkMode(), 'text-gray-100': isDarkMode()}">Call Management</h3>
                <p class="mt-1 text-sm" [ngClass]="{'text-gray-500': !isDarkMode(), 'text-gray-400': isDarkMode()}">Track and analyze your calling activity</p>
              </div>
              <div class="border-t" [ngClass]="{'border-gray-100': !isDarkMode(), 'border-gray-700': isDarkMode()}">
                <div class="py-1">
                  <a routerLink="/calls" (click)="closeAllDesktopMenus()" class="cursor-pointer flex items-center px-4 py-3 text-sm" [ngClass]="{'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-300 hover:bg-gray-700': isDarkMode()}">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    History
                  </a>
                  <a *ngIf="!this.loading && this.partner && this.partner.is === true && this.partner.id === 'meetzy-fkldasfhlajdhgshg'" routerLink="/phones" (click)="closeAllDesktopMenus()" class="cursor-pointer flex items-center px-4 py-3 text-sm" [ngClass]="{'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-300 hover:bg-gray-700': isDarkMode()}">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                    </svg>
                    Phones
                  </a>
                  <a routerLink="/trends" (click)="closeAllDesktopMenus()" class="cursor-pointer flex items-center px-4 py-3 text-sm" [ngClass]="{'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-300 hover:bg-gray-700': isDarkMode()}">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                    Trends
                  </a>
                  <a routerLink="/evaluation-trends" (click)="closeAllDesktopMenus()" class="cursor-pointer flex items-center px-4 py-3 text-sm" [ngClass]="{'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-300 hover:bg-gray-700': isDarkMode()}">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Evaluations
                    <span class="ml-2 inline-flex items-center rounded-md bg-violet-50 px-2 py-1 text-xs font-medium text-violet-700 ring-1 ring-inset ring-violet-600/20">New</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- CRM -->
          <div class="relative inline-block" *ngIf="!this.loading && userCanAccessCrm">
            <div class="cursor-pointer gap-2 h-full inline-flex cursor-pointer items-center border-b-2 px-1 pt-1 text-base font-medium crm-menu-trigger" 
                 [ngClass]="{'text-gray-900 hover:text-gray-700 border-slate-300 hover:border-emerald-300': !isDarkMode(), 'text-gray-100 hover:text-gray-300 border-gray-600 hover:border-emerald-400': isDarkMode()}"
                 [class.border-emerald-500]="router.url.includes('crm') || router.url.includes('crm/segments')"
                 (click)="toggleCrmMenu($event)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
              </svg>
              CRM 
              <svg class="size-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            <div id="crm-menu" class="hidden absolute z-40 mt-2 w-72 rounded-md focus:outline-none" [ngClass]="{'bg-white shadow-lg ring-1 ring-black ring-opacity-5': !isDarkMode(), 'bg-gray-800 shadow-2xl shadow-black/50 ring-1 ring-gray-600 border border-gray-600': isDarkMode()}">
              <div class="p-4">
                <h3 class="text-base font-semibold" [ngClass]="{'text-gray-900': !isDarkMode(), 'text-gray-100': isDarkMode()}">Customer Relationship Management</h3>
                <p class="mt-1 text-sm" [ngClass]="{'text-gray-500': !isDarkMode(), 'text-gray-400': isDarkMode()}">Manage your customers and segments</p>
              </div>
              <div class="border-t" [ngClass]="{'border-gray-100': !isDarkMode(), 'border-gray-700': isDarkMode()}">
                <div class="py-1">
                  <a routerLink="/crm" (click)="closeAllDesktopMenus()" class="cursor-pointer flex items-center px-4 py-3 text-sm" [ngClass]="{'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-300 hover:bg-gray-700': isDarkMode()}">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 mr-3 text-gray-400">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
                    </svg>
                    Contacts
                  </a>
                  <a routerLink="/crm/segments" (click)="closeAllDesktopMenus()" class="cursor-pointer flex items-center px-4 py-3 text-sm" [ngClass]="{'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-300 hover:bg-gray-700': isDarkMode()}">
                    <svg class="h-5 w-5 mr-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                    </svg>
                    Segments
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- MARKETING & INSIGHTS -->
          <!-- <div class="relative inline-block">
            <div class="cursor-pointer gap-2 h-full inline-flex cursor-pointer items-center border-b-2 px-1 pt-1 text-base font-medium marketing-menu-trigger" 
                 [ngClass]="{'text-gray-900 hover:text-gray-700 border-slate-300 hover:border-emerald-300': !isDarkMode(), 'text-gray-100 hover:text-gray-300 border-gray-600 hover:border-emerald-400': isDarkMode()}"
                 [class.border-emerald-500]="router.url.includes('/marketing') || router.url.includes('/insights')"
                 (click)="toggleMarketingMenu($event)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
              </svg>
              Marketing & Insights
              <svg class="size-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            <div id="marketing-menu" class="hidden absolute z-40 mt-2 w-72 rounded-md focus:outline-none" [ngClass]="{'bg-white shadow-lg ring-1 ring-black ring-opacity-5': !isDarkMode(), 'bg-gray-800 shadow-2xl shadow-black/50 ring-1 ring-gray-600 border border-gray-600': isDarkMode()}">
              <div class="p-4">
                <h3 class="text-base font-semibold" [ngClass]="{'text-gray-900': !isDarkMode(), 'text-gray-100': isDarkMode()}">Marketing & Insights</h3>
                <p class="mt-1 text-sm" [ngClass]="{'text-gray-500': !isDarkMode(), 'text-gray-400': isDarkMode()}">Track and analyze your calls and insights</p>
              </div>
              <div class="border-t" [ngClass]="{'border-gray-100': !isDarkMode(), 'border-gray-700': isDarkMode()}">
                <div class="py-1">
                  <a routerLink="/marketing" (click)="closeAllDesktopMenus()" class="cursor-pointer flex items-center px-4 py-3 text-sm" [ngClass]="{'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-300 hover:bg-gray-700': isDarkMode()}">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 mr-3 text-gray-400">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
                    </svg>
                    Marketing
                  </a>
                  <a routerLink="/insights" (click)="closeAllDesktopMenus()" class="cursor-pointer flex items-center px-4 py-3 text-sm" [ngClass]="{'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-300 hover:bg-gray-700': isDarkMode()}">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 mr-3 text-gray-400">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z" />
                    </svg>
                    Insights
                  </a>
                </div>
              </div>
            </div>
          </div> -->

          <!-- TICKETS -->
          <a href="#" routerLink="/tickets" routerLinkActive="border-b-2 border-emerald-500" class="cursor-pointer gap-2 inline-flex items-center border-b-2 px-1 pt-1 text-base font-medium" [ngClass]="{'text-gray-900 hover:text-gray-700 border-slate-300 hover:border-emerald-300': !isDarkMode(), 'text-gray-100 hover:text-gray-300 border-gray-600 hover:border-emerald-400': isDarkMode()}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5"><path stroke-linecap="round" stroke-linejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
          </svg>
          Tickets 
        </a>

        <!-- DOCS -->
        <a *ngIf="(!this.loading && (!this.partner || !this.partner.is)) || (!this.loading && this.partner && this.partner.is === true && this.partner.id !== 'iue92q38yr7etoversoft14fihlaiwuf08tf')" [href]="getDocsUrl()" target="_blank" class="flex items-center border-l-4 border-transparent py-3 pl-4 pr-4 text-base font-medium hover:border-emerald-300" [ngClass]="{'text-gray-600 hover:bg-gray-50 hover:text-gray-800': !isDarkMode(), 'text-gray-300 hover:bg-gray-700 hover:text-gray-100': isDarkMode()}" title="Ayuda para esta página">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 size-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
          </svg>
          Docs
        </a>
      </div>

      <!-- USER MENU -->
      <div class="hidden sm:ml-6 sm:flex sm:items-center">
        
        <!-- What's New button -->
        <button *ngIf="changelogVersions.length > 0"
                (click)="openChangelogModal()"
                class="relative mr-3 p-2 rounded-lg transition-colors"
                [ngClass]="{
                  'hover:bg-gray-100 text-gray-500 hover:text-gray-700': !isDarkMode(),
                  'hover:bg-gray-700 text-gray-400 hover:text-gray-200': isDarkMode()
                }"
                title="What's New">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09Z" />
          </svg>
          <span *ngIf="changelogHasNew"
                class="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-emerald-500 rounded-full border-2"
                [ngClass]="{'border-white': !isDarkMode(), 'border-gray-800': isDarkMode()}">
          </span>
        </button>

        <!-- Theme Toggle (only visible on generator route) -->
        <div *ngIf="shouldShowThemeToggle()" class="mr-4">
          <app-theme-toggle 
            [isDarkMode]="darkModeEnabled" 
            (themeChange)="onThemeChange($event)">
          </app-theme-toggle>
        </div>

        <!-- Profile dropdown -->
        <div class="relative ml-3">
          <div>
            <button type="button" (click)="toggleUserMenu()" class="relative flex rounded-lg text-sm focus:outline-none" [ngClass]="{'bg-red hover:bg-slate-100 hover:ring-slate-500': !isDarkMode(), 'bg-gray-700 hover:bg-gray-600 hover:ring-gray-400': isDarkMode()}" id="user-menu-button" aria-expanded="false" aria-haspopup="true">
              <span class="absolute -inset-1.5"></span>
              <span class="sr-only">Open user menu</span>
              <span class="flex h-9 w-9 rounded-lg border ring-2 ring-offset-2 justify-center items-center" [ngClass]="{'border-slate-300 ring-slate-100 hover:ring-slate-500': !isDarkMode(), 'border-gray-600 ring-gray-700 hover:ring-gray-500': isDarkMode()}">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6" [ngClass]="{'text-gray-600': !isDarkMode(), 'text-gray-300': isDarkMode()}">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                </svg>
              </span>
              <img class="hidden h-8 w-8 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="">
            </button>
          </div>

          <div id="user-menu" data-track-zone="Menú de usuario" class="hidden absolute right-0 z-40 mt-2 w-56 origin-top-right divide-y rounded-md focus:outline-none z-[99999]" [ngClass]="{'divide-gray-100 bg-white shadow-lg ring-1 ring-black ring-opacity-5': !isDarkMode(), 'divide-gray-700 bg-gray-800 shadow-2xl shadow-black/50 ring-1 ring-gray-600 border border-gray-600': isDarkMode()}" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
            <div class="px-4 py-3 shadow-2xl shadow-cyan-500/20 opacity-50" ro le="none">
              <p class="text-sm text-slate-500" role="none">Signed in as...</p>
              <p class="truncate text-sm font-bold" [ngClass]="{'text-gray-900': !isDarkMode(), 'text-gray-100': isDarkMode()}" role="none">{{email}}</p>
            </div>
            <div class="py-1" role="none">
              <!-- Active: "bg-gray-100 text-gray-900", Not Active: "text-gray-700" -->
              <a href="#" routerLink="/account" (click)="toggleUserMenu()" class="block px-4 py-2 text-sm font-bold" [ngClass]="{'text-gray-700': !isDarkMode(), 'text-gray-300': isDarkMode()}" role="menuitem" tabindex="-1" id="menu-item-0">Account settings</a>
              <a href="#" routerLink="/integrations" (click)="toggleUserMenu()" class="block px-4 py-2 text-sm font-bold" [ngClass]="{'text-gray-700': !isDarkMode(), 'text-gray-300': isDarkMode()}" role="menuitem" tabindex="-1">Integrations</a>
              <a href="#" routerLink="/members" (click)="toggleUserMenu()" class="block px-4 py-2 text-sm font-bold" [ngClass]="{'text-gray-700': !isDarkMode(), 'text-gray-300': isDarkMode()}" role="menuitem" tabindex="-1" id="menu-item-1">Members</a>
              <a href="#" routerLink="/companies" *ngIf="!this.loading && this.partner && this.partner.is === true && this.partner.id === 'meetzy-fkldasfhlajdhgshg' && (email=='jorge@meetzy.io' || email=='support@meetzy.io' || email=='david@meetzy.io' || email=='tabata@meetzy.io' || email=='lorenzo@meetzy.io')" (click)="toggleUserMenu()" class="block px-4 py-2 text-sm font-bold" [ngClass]="{'text-gray-700': !isDarkMode(), 'text-gray-300': isDarkMode()}" role="menuitem" tabindex="-1" id="menu-item-2">Companies</a>
              <a href="#" routerLink="/token-manager" (click)="toggleUserMenu()" class="block px-4 py-2 text-sm font-bold" [ngClass]="{'text-gray-700': !isDarkMode(), 'text-gray-300': isDarkMode()}" role="menuitem" tabindex="-1" id="menu-item-3">Tokens</a>
              <!-- 2FA Security Option (Admin Only) -->
              <a *ngIf="isAdminUser" (click)="open2FASetup(); toggleUserMenu()" class="cursor-pointer block px-4 py-2 text-sm font-bold text-emerald-500 hover:text-emerald-400" role="menuitem" tabindex="-1">
                <svg class="inline w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                </svg>
                Security (2FA)
              </a>
              <!-- User Activity (Admin Only) -->
              <a *ngIf="isAdminUser" routerLink="/user-activity" (click)="toggleUserMenu()" class="cursor-pointer block px-4 py-2 text-sm font-bold text-amber-500 hover:text-amber-400" role="menuitem" tabindex="-1">
                <svg class="inline w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                </svg>
                User Activity
              </a>
              <a href="#" routerLink="/call-logs" *ngIf="userCanAccessCallLogs" (click)="toggleUserMenu()" class="block px-4 py-2 mt-2 text-sm font-bold border-t pt-4" [ngClass]="{'text-gray-700 border-gray-200': !isDarkMode(), 'text-gray-300 border-gray-600': isDarkMode()}" role="menuitem" tabindex="-1" id="menu-item-4">
                <svg class="inline w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
                Logs
              </a>
            </div>
            <div class="py-1" role="none">
              <form method="POST" action="#" role="none">
                <button type="button" (click)="logout()" class="block w-full px-4 py-2 text-left text-sm text-red-700" role="menuitem" tabindex="-1" id="menu-item-3">Sign out</button>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</nav>

<!-- Mobile menu, show/hide based on menu state -->
<div [class.hidden]="!mobileMenuOpen" data-track-zone="Menú móvil" class="sm:hidden shadow-lg fixed top-16 left-0 right-0 z-[100] max-h-[calc(100vh-4rem)] overflow-y-auto" [ngClass]="{'bg-white': !isDarkMode(), 'bg-gray-800': isDarkMode()}" id="mobile-menu">
  <div class="space-y-1 pb-3 pt-2">
    <!-- Agents Mobile -->
    <div>
      <button (click)="toggleAgentsMenu($event)" class="flex w-full items-center justify-between border-l-4 border-transparent py-3 pl-4 pr-4 text-base font-medium text-gray-600 hover:border-emerald-300 hover:bg-gray-50 hover:text-gray-800" [class.border-emerald-500]="router.url.includes('/playbooks') || router.url.includes('/agents')">
        <div class="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 size-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09Z" />
          </svg>
          Agents
        </div>
        <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      <div id="mobile-agents-menu" class="hidden pl-7 py-2 space-y-2">
        <a routerLink="/agents" (click)="toggleMobileMenu()" class="flex items-center pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-gray-800">All Agents</a>
        <a routerLink="/agents/voices" (click)="toggleMobileMenu()" class="flex items-center pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-gray-800">Voice Library</a>
      </div>
    </div>

    <!-- Calls Mobile -->
    <div>
      <button (click)="toggleCallsMenu($event)" class="flex w-full items-center justify-between border-l-4 border-transparent py-3 pl-4 pr-4 text-base font-medium text-gray-600 hover:border-emerald-300 hover:bg-gray-50 hover:text-gray-800" [class.border-emerald-500]="router.url.includes('/calls') || router.url.includes('/trends') || router.url.includes('/phones') || router.url.includes('/evaluation-trends')">
        <div class="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 size-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
          </svg>
          Calls
        </div>
        <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      <div id="mobile-calls-menu" class="hidden pl-7 py-2 space-y-2">
        <a routerLink="/calls" (click)="toggleMobileMenu()" class="flex items-center pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-gray-800">History</a>
        <a *ngIf="!this.loading && this.partner && this.partner.is === true && this.partner.id === 'meetzy-fkldasfhlajdhgshg'" routerLink="/phones" (click)="toggleMobileMenu()" class="flex items-center pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-gray-800">Phones</a>
        <a routerLink="/trends" (click)="toggleMobileMenu()" class="flex items-center pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-gray-800">
          Trends
        </a>
        <a routerLink="/evaluation-trends" (click)="toggleMobileMenu()" class="flex items-center pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-gray-800">
          Evaluations
          <span class="ml-2 inline-flex items-center rounded-md bg-violet-50 px-2 py-1 text-xs font-medium text-violet-700 ring-1 ring-inset ring-violet-600/20">New</span>
        </a>
      </div>
    </div>

    <!-- CRM Mobile -->
    <div *ngIf="!this.loading && userCanAccessCrm">
      <button (click)="toggleCrmMenu($event)" class="flex w-full items-center justify-between border-l-4 border-transparent py-3 pl-4 pr-4 text-base font-medium text-gray-600 hover:border-emerald-300 hover:bg-gray-50 hover:text-gray-800" [class.border-emerald-500]="router.url.includes('crm') || router.url.includes('crm/segments')">
        <div class="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 size-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
          </svg>
          CRM
          <span class="ml-2 inline-flex items-center rounded-md bg-orange-50 px-2 py-1 text-xs font-medium text-orange-700 ring-1 ring-inset ring-orange-600/20">Beta</span>
        </div>
        <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      <div id="mobile-crm-menu" class="hidden pl-7 py-2 space-y-2">
        <a routerLink="/crm" (click)="toggleMobileMenu()" class="flex items-center pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-gray-800">Contacts</a>
        <a routerLink="/crm/segments" (click)="toggleMobileMenu()" class="flex items-center pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-gray-800">Segments</a>
      </div>
    </div>

    <!-- Marketing & Insights Mobile -->
    <div>
      <button (click)="toggleMarketingMenu($event)" class="flex w-full items-center justify-between border-l-4 border-transparent py-3 pl-4 pr-4 text-base font-medium text-gray-600 hover:border-emerald-300 hover:bg-gray-50 hover:text-gray-800" [class.border-emerald-500]="router.url.includes('/marketing') || router.url.includes('/insights')">
        <div class="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 size-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
          </svg>
          Marketing & Insights
        </div>
        <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      <div id="mobile-marketing-menu" class="hidden pl-7 py-2 space-y-2">
        <a routerLink="/marketing" (click)="toggleMobileMenu()" class="flex items-center pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-gray-800">Marketing</a>
        <a routerLink="/insights" (click)="toggleMobileMenu()" class="flex items-center pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-gray-800">Insights</a>
      </div>
    </div>

    <!-- Single Links Mobile -->
    <a routerLink="/tickets" (click)="toggleMobileMenu()" class="flex items-center border-l-4 border-transparent py-3 pl-4 pr-4 text-base font-medium text-gray-600 hover:border-emerald-300 hover:bg-gray-50 hover:text-gray-800" [class.border-emerald-500]="router.url.includes('/tickets')">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 size-5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
      </svg>
      Tickets
    </a>
    
    <a *ngIf="(!this.loading && (!this.partner || !this.partner.is)) || (!this.loading && this.partner && this.partner.is === true && this.partner.id !== 'iue92q38yr7etoversoft14fihlaiwuf08tf')" [href]="getDocsUrl()" target="_blank" class="flex items-center border-l-4 border-transparent py-3 pl-4 pr-4 text-base font-medium hover:border-emerald-300" [ngClass]="{'text-gray-600 hover:bg-gray-50 hover:text-gray-800': !isDarkMode(), 'text-gray-300 hover:bg-gray-700 hover:text-gray-100': isDarkMode()}">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 size-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
      </svg>
      Docs
    </a>
  </div>
  
  <!-- Mobile User Options -->
  <div class="border-t border-gray-200 pb-3 pt-4">
    <div class="flex items-center px-5">
      <div class="flex-shrink-0">
        <div class="h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 text-gray-600">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
          </svg>
        </div>
      </div>
      <div class="ml-3 text-sm font-medium text-gray-700 truncate max-w-[200px]">{{email}}</div>
      
      <!-- Theme Toggle for mobile (only visible on generator route) -->
      <div *ngIf="shouldShowThemeToggle()" class="ml-auto">
        <app-theme-toggle 
          [isDarkMode]="darkModeEnabled" 
          (themeChange)="onThemeChange($event)">
        </app-theme-toggle>
      </div>
    </div>
    <div class="mt-3 space-y-1">
      <a *ngIf="!this.loading && this.partner && this.partner.is === true && this.partner.id === 'meetzy-fkldasfhlajdhgshg' && (email=='jorge@meetzy.io' || email=='borja@meetzy.io')" routerLink="/cost-calculator" (click)="toggleMobileMenu()" class="block px-4 py-2 text-base font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800">Cost Calculator</a>
      <a routerLink="/account" (click)="toggleMobileMenu()" class="block px-4 py-2 text-base font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800">Account settings</a>
      <a routerLink="/integrations" (click)="toggleMobileMenu()" class="block px-4 py-2 text-base font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800">Integrations</a>
      <a routerLink="/members" (click)="toggleMobileMenu()" class="block px-4 py-2 text-base font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800">Members</a>
      <a *ngIf="!this.loading && this.partner && this.partner.is === true && this.partner.id === 'meetzy-fkldasfhlajdhgshg' && (email=='jorge@meetzy.io' || email=='borja@meetzy.io' || email=='david@meetzy.io' || email=='lorenzo@meetzy.io')" routerLink="/companies" (click)="toggleMobileMenu()" class="block px-4 py-2 text-base font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800">Companies</a>
      <a routerLink="/token-manager" (click)="toggleMobileMenu()" class="block px-4 py-2 text-base font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800">Tokens</a>
      <button (click)="logout()" class="block w-full text-left px-4 py-2 text-base font-medium text-red-700 hover:bg-gray-100">Sign out</button>
    </div>
  </div>
</div>

<!-- Feedback Modal -->
<div 
  *ngIf="feedbackModalOpen"
  class="fixed bottom-16 left-4 z-50 max-w-sm sm:max-w-md w-full transition-all duration-300 ease-in-out transform"
  [ngClass]="{'opacity-100 translate-y-0': !feedbackModalClosing, 'opacity-0 translate-y-4': feedbackModalClosing}">
  <div class="bg-white rounded-lg shadow-xl overflow-hidden">
    <div class="bg-emerald-500 px-4 py-3 flex justify-between items-center">
      <h3 class="text-lg font-medium text-white">Send Feedback</h3>
      <button (click)="toggleFeedbackModal()" data-track-label="Cerrar formulario de feedback" class="text-white hover:text-gray-200">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    
    <div class="p-4">
      <form (submit)="submitFeedback($event)">
        <!-- Rating -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">How would you rate your experience?</label>
          <div class="flex items-center space-x-1">
            <ng-container *ngFor="let i of [1,2,3,4,5]">
              <button 
                type="button"
                (click)="setFeedbackRating(i)"
                class="text-2xl focus:outline-none"
                [class.text-yellow-400]="feedbackRating >= i"
                [class.text-gray-300]="feedbackRating < i">
                ★
              </button>
            </ng-container>
          </div>
        </div>
        
        <!-- Category -->
        <div class="mb-4">
          <label for="feedback-category" class="block text-sm font-medium text-gray-700 mb-1">Category</label>
          <select 
            id="feedback-category" 
            [(ngModel)]="feedbackCategory" 
            name="category"
            class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
            <option value="General">General</option>
            <option value="Bug Report">Bug Report</option>
            <option value="Feature Request">Feature Request</option>
            <option value="UI/UX">UI/UX</option>
            <option value="Performance">Performance</option>
          </select>
        </div>
        
        <!-- Message -->
        <div class="mb-4">
          <label for="feedback-message" class="block text-sm font-medium text-gray-700 mb-1">Your feedback</label>
          <textarea 
            id="feedback-message" 
            [(ngModel)]="feedbackMessage" 
            name="message"
            rows="4" 
            class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm"
            placeholder="Tell us what you think..."></textarea>
        </div>
        
        <!-- Submit -->
        <div class="mt-5 flex justify-end">
          <button 
            type="button" 
            (click)="toggleFeedbackModal()" 
            class="mr-3 inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500">
            Cancel
          </button>
          <button 
            type="submit" 
            [disabled]="!feedbackMessage || feedbackSubmitting"
            [class.opacity-50]="!feedbackMessage || feedbackSubmitting"
            [class.cursor-not-allowed]="!feedbackMessage || feedbackSubmitting"
            class="inline-flex justify-center items-center px-4 py-2 text-sm font-medium text-white bg-emerald-500 border border-transparent rounded-md hover:bg-emerald-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 min-w-[90px]">
            <svg *ngIf="feedbackSubmitting" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ feedbackSubmitting ? 'Sending...' : 'Submit' }}
          </button>
        </div>
      </form>
      
      <!-- Success message -->
      <div *ngIf="feedbackSubmitted" class="mt-3 p-3 bg-green-100 border border-green-300 rounded-md text-green-800 text-sm">
        Thank you for your feedback! We appreciate your input.
      </div>
      
      <!-- Error message -->
      <div *ngIf="feedbackError" class="mt-3 p-3 bg-red-100 border border-red-300 rounded-md text-red-800 text-sm">
        There was an error submitting your feedback. Please try again.
      </div>
    </div>
  </div>
</div>

<div [ngClass]="{'py-6 sm:py-10': !isFullWidthRoute}">
  <header *ngIf="!isFullWidthRoute">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
    </div>
  </header>
  <main>
    <div [ngClass]="{
      'mx-auto px-4 py-4 sm:py-8 sm:px-6 lg:px-8': !isFullWidthRoute,
      'bg-white': !isDarkMode(),
      'bg-gray-900': isDarkMode(),
      'pb-16 sm:pb-16': isLoggedIn && !isLoginRoute && !isAdvancedEditorRoute
    }">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
<app-billy-consumption-panel
  *ngIf="isLoggedIn && !isLoginRoute && !isAdvancedEditorRoute"
  [isDarkMode]="isDarkMode()">
</app-billy-consumption-panel>
</div>

<!-- unauthorized notification-->
<div id="modal-unauthorized" class="hidden fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-end sm:justify-end">
  <div class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
    <div class="p-4">
      <div class="flex items-start">
        <div class="flex-shrink-0">
          <!-- Heroicon name: exclamation -->
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6 w-6 text-red-400" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.5-1.67 1.73-3l-6.93-12c-.77-1.33-2.73-1.33-3.5 0l-6.93 12c-.77 1.33.19 3 1.73 3Z" />
          </svg>
        </div>
        <div class="ml-3 w-0 flex-1 pt-0.5">
          <p class="text-sm font-medium text-gray-900">Permission denied</p>
          <p class="mt-1 text-sm text-gray-500">You do not have permission to perform this action.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Changelog "What's New" Modal -->
<div *ngIf="showChangelogModal" class="fixed inset-0 z-[9999] overflow-y-auto">
  <div class="fixed inset-0 bg-black/60 backdrop-blur-sm" (click)="closeChangelogModal()"></div>

  <div class="flex min-h-full items-center justify-center p-4">
    <div class="relative w-full max-w-xl rounded-3xl shadow-2xl overflow-hidden transform transition-all"
         [ngClass]="{'bg-white': !isDarkMode(), 'bg-gray-900': isDarkMode()}">

      <!-- Close button (floating, top-right) -->
      <button (click)="closeChangelogModal()"
              data-track-label="Cerrar modal de novedades"
              class="absolute top-5 right-5 z-10 p-1.5 rounded-full transition-colors"
              [ngClass]="{
                'hover:bg-gray-100 text-gray-300 hover:text-gray-600': !isDarkMode(),
                'hover:bg-gray-800 text-gray-600 hover:text-gray-300': isDarkMode()
              }"
              aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>

      <!-- Content -->
      <div class="px-10 pt-10 pb-2 max-h-[70vh] overflow-y-auto">

        <!-- Eyebrow -->
        <p class="text-[11px] font-medium tracking-[0.18em] uppercase mb-3"
           [ngClass]="{'text-emerald-600': !isDarkMode(), 'text-emerald-400': isDarkMode()}">
          What's New
        </p>

        <!-- Loading -->
        <div *ngIf="changelogLoading" class="flex items-center justify-center py-16">
          <div class="animate-spin rounded-full h-6 w-6 border-2 border-emerald-500 border-t-transparent"></div>
        </div>

        <!-- Version list -->
        <div *ngIf="!changelogLoading">
          <div *ngFor="let version of changelogVersions; let first = first; let last = last"
               [class.mt-12]="!first"
               [class.pt-12]="!first"
               class="relative"
               [ngClass]="{
                 'border-t border-gray-100': !first && !isDarkMode(),
                 'border-t border-gray-800': !first && isDarkMode()
               }">

            <!-- Version meta line -->
            <div class="flex items-baseline gap-3 mb-2">
              <h2 class="text-3xl font-light tracking-tight tabular-nums"
                  [ngClass]="{'text-gray-900': !isDarkMode(), 'text-white': isDarkMode()}">
                {{ version.version }}
              </h2>
              <span class="text-xs font-light"
                    [ngClass]="{'text-gray-400': !isDarkMode(), 'text-gray-500': isDarkMode()}">
                {{ formatChangelogDate(version.release_date) }}
              </span>
              <span *ngIf="first && changelogHasNew"
                    class="inline-flex items-center gap-1.5 text-[10px] font-medium tracking-wider uppercase"
                    [ngClass]="{'text-emerald-600': !isDarkMode(), 'text-emerald-400': isDarkMode()}">
                <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
                New
              </span>
            </div>

            <!-- Version title -->
            <h3 class="text-lg font-medium mb-8"
                [ngClass]="{'text-gray-700': !isDarkMode(), 'text-gray-300': isDarkMode()}">
              {{ version.title }}
            </h3>

            <!-- Change items -->
            <ul class="space-y-5">
              <li *ngFor="let item of version.items"
                  class="flex items-start gap-5">
                <!-- Type label column (fixed width for alignment) -->
                <span class="flex items-center gap-2 w-20 shrink-0 pt-[0.4rem]">
                  <span class="w-1.5 h-1.5 rounded-full shrink-0"
                        [ngClass]="{
                          'bg-emerald-500': item.type === 'feature',
                          'bg-blue-500': item.type === 'improvement',
                          'bg-amber-500': item.type === 'bugfix'
                        }"></span>
                  <span class="text-[10px] font-medium tracking-[0.14em] uppercase"
                        [ngClass]="{
                          'text-gray-400': !isDarkMode(),
                          'text-gray-500': isDarkMode()
                        }">
                    {{ getChangelogItemLabel(item.type) }}
                  </span>
                </span>
                <!-- Title + description + optional image -->
                <div class="flex-1">
                  <h4 *ngIf="item.title"
                      class="text-[15px] font-medium mb-1"
                      [ngClass]="{'text-gray-900': !isDarkMode(), 'text-white': isDarkMode()}">
                    {{ item.title }}
                  </h4>
                  <span class="text-[15px] leading-relaxed font-light"
                        [ngClass]="{'text-gray-700': !isDarkMode(), 'text-gray-300': isDarkMode()}">
                    {{ item.description }}
                  </span>
                  <div *ngIf="item.image_url"
                       class="mt-3 rounded-2xl overflow-hidden shadow-xl"
                       [ngClass]="{
                         'ring-1 ring-gray-300 bg-gray-50': !isDarkMode(),
                         'ring-1 ring-gray-700 bg-gray-950': isDarkMode()
                       }">
                    <img [src]="item.image_url"
                         [alt]="item.title || item.description"
                         loading="lazy"
                         class="w-full max-h-72 object-contain" />
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <!-- Empty state -->
          <div *ngIf="changelogVersions.length === 0" class="text-center py-16">
            <p class="text-sm font-light"
               [ngClass]="{'text-gray-400': !isDarkMode(), 'text-gray-500': isDarkMode()}">
              No updates available yet.
            </p>
          </div>
        </div>
      </div>

      <!-- Footer (no chrome, just generous padding) -->
      <div class="px-10 pt-6 pb-8 flex justify-end">
        <button (click)="closeChangelogModal()"
                class="px-5 py-2 rounded-full text-sm font-medium transition-colors"
                [ngClass]="{
                  'text-gray-900 hover:text-emerald-600': !isDarkMode(),
                  'text-gray-100 hover:text-emerald-400': isDarkMode()
                }">
          Continue →
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Encuesta de producto (una sola vez, hasta que se descarta) -->
<div *ngIf="showSurveyModal" class="fixed inset-0 z-[9999] overflow-y-auto">
  <div class="fixed inset-0 bg-black/60 backdrop-blur-sm" (click)="closeSurveyModal()"></div>

  <div class="flex min-h-full items-center justify-center p-4">
    <div class="relative w-full max-w-xl h-[85vh] rounded-3xl shadow-2xl overflow-hidden transform transition-all"
         [ngClass]="{'bg-white': !isDarkMode(), 'bg-gray-900': isDarkMode()}">

      <button (click)="closeSurveyModal()"
              data-track-label="Cerrar modal de encuesta"
              class="absolute top-5 right-5 z-10 p-1.5 rounded-full transition-colors"
              [ngClass]="{
                'hover:bg-gray-100 text-gray-300 hover:text-gray-600': !isDarkMode(),
                'hover:bg-gray-800 text-gray-600 hover:text-gray-300': isDarkMode()
              }"
              aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>

      <iframe *ngIf="surveyUrl" [src]="surveyUrl" class="w-full h-full border-0" title="Encuesta de producto Meetzy"></iframe>
    </div>
  </div>
</div>

<!-- 2FA Setup Modal -->
<div *ngIf="show2FASetup" class="fixed inset-0 z-[9999] overflow-y-auto">
  <!-- Backdrop -->
  <div class="fixed inset-0 bg-black/60 backdrop-blur-sm" (click)="close2FASetup()"></div>
  
  <!-- Modal Container -->
  <div class="flex min-h-full items-center justify-center p-4">
    <div class="relative w-full max-w-lg">
      <!-- Close Button -->
      <button (click)="close2FASetup()" data-track-label="Cerrar configuración 2FA" class="absolute -top-2 -right-2 z-10 w-8 h-8 bg-slate-700 hover:bg-slate-600 rounded-full flex items-center justify-center text-slate-400 hover:text-white transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      
      <!-- 2FA Setup Component -->
      <app-two-factor-setup></app-two-factor-setup>
    </div>
  </div>
</div>
